module.exports = __webpack_public_path__ + "static/media/frameCorrect.9826e0cb.png";